import { atom, RecoilState } from 'recoil'

const featureFlagAtom: RecoilState<object> = atom({
  key: 'featureFlagState',
  default: {}
})

export default featureFlagAtom
